import React from 'react';
import { Package, Check, AlertTriangle } from 'lucide-react';

/**
 * Компонент секции дополнительных предметов
 */
const ExtraItemsSection = ({ 
  formData, 
  handleInputChange, 
  handleExtraItemToggle,
  errors, 
  extraItemsList 
}) => {
  // Если раздел дополнительных предметов не активирован, показываем только чекбокс
  if (!formData.hasExtraItems) {
    return (
      <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            name="hasExtraItems"
            checked={formData.hasExtraItems}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2 text-base font-medium text-gray-900 dark:text-white flex items-center">
            <Package className="w-5 h-5 mr-2 text-purple-500" />
            Включить дополнительные предметы
          </span>
        </label>
      </div>
    );
  }

  return (
    <div className="mb-6 bg-purple-50 dark:bg-purple-900/20 p-4 rounded-lg border border-purple-200 dark:border-purple-800">
      <div className="flex items-center justify-between mb-4">
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            name="hasExtraItems"
            checked={formData.hasExtraItems}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2 text-base font-medium text-gray-900 dark:text-white flex items-center">
            <Package className="w-5 h-5 mr-2 text-purple-500" />
            Дополнительные предметы
          </span>
        </label>
        
        <span className="text-xs text-purple-700 dark:text-purple-300 font-medium">
          Выбрано: {formData.extraItems.length}
        </span>
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-2">
        {extraItemsList.map((item) => {
          const isSelected = formData.extraItems.includes(item.id);
          
          return (
            <div 
              key={item.id}
              onClick={() => handleExtraItemToggle(item.id)}
              className={`
                p-3 rounded-lg border cursor-pointer transition-colors
                ${isSelected
                  ? 'bg-purple-100 border-purple-300 dark:bg-purple-900/30 dark:border-purple-700' 
                  : 'bg-white border-gray-200 hover:bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:hover:bg-gray-650'}
              `}
            >
              <div className="flex items-start">
                <div className={`
                  flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center
                  ${isSelected
                    ? 'bg-purple-500 text-white' 
                    : 'bg-gray-200 dark:bg-gray-600'}
                `}>
                  {isSelected && <Check className="w-3 h-3" />}
                </div>
                <div className="ml-2">
                  <div className="flex items-center">
                    <span className="text-sm font-medium text-gray-900 dark:text-white">
                      {item.name}
                    </span>
                    <span className="ml-2 text-xs font-medium text-gray-500 dark:text-gray-400">
                      {item.weight} кг
                    </span>
                  </div>
                  <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      
      {formData.extraItems.length > 0 && (
        <div className="mt-4 bg-yellow-50 dark:bg-yellow-900/20 p-3 rounded-lg border border-yellow-100 dark:border-yellow-800 flex items-start">
          <AlertTriangle className="w-5 h-5 text-yellow-500 flex-shrink-0 mt-0.5" />
          <p className="ml-2 text-sm text-yellow-700 dark:text-yellow-300">
            За некоторые предметы может взиматься дополнительная плата. Также могут быть особые требования к упаковке.
            Рекомендуем уточнить правила перевозки у вашей авиакомпании.
          </p>
        </div>
      )}
    </div>
  );
};

export default ExtraItemsSection;